import { combineReducers } from '@reduxjs/toolkit'
import globalReducer from './global'
import authReducer from './auth'
import customerStepsReducer from './customerSteps'
import dashboardReducer from './dashboard'
import customerFilesReducer from './customerFiles'
import customerReducer from './customer'
import passportReducer from './passport'
import paymentCardsReducer from './paymentCards'
import tripAirReducer from './tripAirSlice'
import misc_docReducer from './misc_doc'
import arnFilesReducer from './arn_files'
import gbApplicationFilesReducer from './gb_application_files'
import apiCallReducer from './apiCallCheckSlice'
import securelinkReducer from './securelinkslice'
import pdfDataReducer from './pdfDataSlice'
import speechCheckListReducer from './speechCheckListSlice'
import eligibilityCheckListReducer from './eligibilityCheckListSlice'
import tripSeaReducer from './tripseaSlice'
import affiliateCompanyReducer from './affiliateCompanySlice'
import affiliateLocationReducer from './affiliateLocationSlice'
import purchaseReceiptReducer from './purchaseReceiptSlice'
import userReducer from './userSlice'
import purchaseTotalReducer from './purchaseTotalSlice'
import loaderReducer from './loaderSlice'
import idleTimeLockReducer from './idleTimeLock'

const rootReducer = combineReducers({
  global: globalReducer,
  auth: authReducer,
  customerSteps: customerStepsReducer,
  dashboard: dashboardReducer,
  customer_files: customerFilesReducer,
  customer: customerReducer,
  passport: passportReducer,
  paymentCards: paymentCardsReducer,
  affiliateCompany: affiliateCompanyReducer,
  affiliateLocation: affiliateLocationReducer,
  misc_douments: misc_docReducer,
  arn_files: arnFilesReducer,
  gb_application_files: gbApplicationFilesReducer,
  apiCall: apiCallReducer,
  securelink: securelinkReducer,
  pdf_data: pdfDataReducer,
  speech_check_list: speechCheckListReducer,
  eligibilityCheckList: eligibilityCheckListReducer,
  tripSea: tripSeaReducer,
  tripAir: tripAirReducer,
  purchaseReceipt: purchaseReceiptReducer,
  user: userReducer,
  purchaseTotal: purchaseTotalReducer,
  loader: loaderReducer,
  idleTime: idleTimeLockReducer
})

export default rootReducer
